export default __webpack_public_path__ + "static/media/trampapo_02_19.eeb7cf57.jpg";